

























import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      message: '',
      shown: false
    }
  },

  computed: {
    alertModalEl(): HTMLDivElement {
      return document.querySelector('.alert-modal') as HTMLDivElement
    },

    modalWindowEl(): HTMLDivElement {
      return document.querySelector('.modal-window') as HTMLDivElement
    },
  },

  methods: {
    alertModalElMousedown() {
      this.modalWindowEl.classList.add('fade-enter-active')
    },

    modalWindowElAnimationend() {
      this.modalWindowEl.classList.remove('fade-enter-active')
    },

    modalWindowElMousedown(event: Event) {
      event.stopPropagation()
    },

    hide(): void {
      this.alertModalEl.removeEventListener('mousedown', this.alertModalElMousedown)
      this.modalWindowEl.removeEventListener('mousedown', this.modalWindowElMousedown)
      this.modalWindowEl.removeEventListener('animationend', this.modalWindowElAnimationend)
      this.shown = false
    },

    show(message: string): void {
      this.message = message
      this.shown = true
      this.$nextTick(() => {
        if (this.alertModalEl !== null && this.modalWindowEl !== null) {
          this.alertModalEl.addEventListener('mousedown', this.alertModalElMousedown)
          this.modalWindowEl.addEventListener('mousedown', this.modalWindowElMousedown)
          this.modalWindowEl.addEventListener('animationend', this.modalWindowElAnimationend)
        }
      })
    }
  },
})
